import { useEffect, useRef, useState } from "react";
import { Phone, PhoneOff, Video } from "lucide-react";
import api from "@/lib/api";

// Polls for incoming 1:1 calls and shows a ringing modal.
export default function IncomingCall({ disabled, onAccept }) {
  const [call, setCall] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    if (disabled) return;
    let stop = false;
    const poll = async () => {
      try {
        const r = await api.get("/calls/incoming");
        if (!stop) setCall(r.data.call || null);
      } catch (e) { /* ignore */ }
    };
    poll();
    const int = setInterval(poll, 3000);
    return () => { stop = true; clearInterval(int); };
  }, [disabled]);

  const accept = async () => {
    if (!call) return;
    try {
      const r = await api.post(`/calls/${call.id}/accept`);
      onAccept?.({ channel: r.data.channel, title: `Call with ${call.from_name}` });
    } catch (e) { /* ignore */ }
    setCall(null);
  };
  const decline = async () => {
    if (!call) return;
    api.post(`/calls/${call.id}/decline`).catch(() => {});
    setCall(null);
  };

  if (!call || disabled) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="incoming-call">
      <div className="w-[320px] rounded-2xl border border-[#2E3242] bg-[#16181F] p-6 text-center shadow-2xl">
        <div className="relative w-20 h-20 mx-auto">
          <img src={call.from_avatar} alt={call.from_name} className="w-20 h-20 rounded-full object-cover border-2 border-red-900/50" />
          <span className="absolute inset-0 rounded-full border-2 border-red-500/40 animate-ping" />
        </div>
        <h3 className="mt-4 font-display font-bold text-lg text-gray-100">{call.from_name}</h3>
        <p className="text-sm text-gray-500 flex items-center justify-center gap-1.5 mt-0.5">
          <Video className="w-3.5 h-3.5" /> Incoming video call…
        </p>
        <div className="mt-6 flex items-center justify-center gap-4">
          <button data-testid="decline-call" onClick={decline}
            className="w-14 h-14 rounded-full bg-red-600 hover:bg-red-500 text-white flex items-center justify-center transition-colors">
            <PhoneOff className="w-6 h-6" />
          </button>
          <button data-testid="accept-call" onClick={accept}
            className="w-14 h-14 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white flex items-center justify-center transition-colors">
            <Phone className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
}
